import { deviceType } from "@tm/isomorphic-utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const CommonLandingPwaWrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  background-color: ${theme.whiteText2};
  padding: 16px;
`;

export const GiFooterWrap = styled.div`
  width: 100%;
`;

export const InsuranceGiCommonLandingPageMainWrapper = styled.div`
  :before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1440' height='256' fill='none'%3E%3Cpath fill='url(%23a)' fill-rule='evenodd' d='M1440 167.207C1224.62 223.655 980.573 255.5 722 255.5c-260.175 0-505.644-32.241-722-89.345V0h1440v167.207Z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='1048.73' y1='0' y2='787.836' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF6D38'/%3E%3Cstop offset='1' stop-color='%23DB7A21'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E"),
      url("https://go-assets.ibcdn.com/u/GI/images/1715677875363-bg-dweb.webp");
    background-size: 100% 382px;
    background-repeat: no-repeat;
    height: 382px;
  }
`;

export const InsuranceCommonLandingPageMainWrapper = styled.div`
  background-size: 100% 685px;
  background-repeat: no-repeat;
  padding-top: 5px;
  position: relative;
  z-index: 2;
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
  }
`;

export const CommonDesktopLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 50px;
  }

  > *:nth-last-child(2) {
    margin-bottom: 0;
  }
`;
